"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiReportRefundQueryDto = void 0;
const types_1 = require("../../../billing-api-contractor/types");
const billing_core_refund_reason_enum_1 = require("../../../../billing-core/billing-core-refund/types/enums/billing-core-refund-reason.enum");
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const transform_json_string_1 = __importDefault(require("../../../../shared/pipes/transform-json-string"));
const key_value_1 = require("../../../../shared/types/key-value");
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class BillingApiReportRefundQueryDto {}
__decorate([(0, swagger_1.ApiProperty)({
  description: `Поиск операций связанных с конкретным(и) провайдером.
    Для поиска тестовых операций, нужно выбрать тестовых провайдеров.`,
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    format: 'uuid'
  }
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportRefundQueryDto.prototype, "providerId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Возвраты с суммой возврата больше либо равно",
  required: false,
  type: 'string',
  format: 'decimal',
  example: '9.65'
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDecimal)({
  decimal_digits: '1,3'
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportRefundQueryDto.prototype, "amountMin", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Возвраты с суммой возврата меньше либо равно",
  required: false,
  type: 'string',
  format: 'decimal',
  example: '19.25'
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDecimal)({
  decimal_digits: '1,3'
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportRefundQueryDto.prototype, "amountMax", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск операций по причине из классификатора",
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    type: 'string',
    enum: Object.values(billing_core_refund_reason_enum_1.BillingCoreRefundReasonEnum)
  }
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportRefundQueryDto.prototype, "reason", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск операций связанных с конкретным(и) charge",
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    format: 'uuid'
  }
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportRefundQueryDto.prototype, "chargeId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск операций связанных с конкретным(и) order",
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    format: 'uuid'
  }
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportRefundQueryDto.prototype, "orderId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск операций связанных с contractorId",
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    format: 'uuid'
  }
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportRefundQueryDto.prototype, "contractorId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Поиск операций связанных с контрагентом`,
  required: false,
  type: String,
  isArray: true,
  nullable: true,
  items: {
    format: "json",
    example: "{\"descriptor\": \"user\", \"externalId\": \"202675c9-0700-4472-bb2e-a2d2c2b2c401\"}"
  }
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), (0, transform_json_string_1.default)(), (0, class_transformer_1.Type)(() => types_1.BillingApiContractorDto), __metadata("design:type", Object)], BillingApiReportRefundQueryDto.prototype, "contractor", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск операций связанных со сделками содержащими мета-данные",
  required: false,
  type: String,
  format: "json",
  example: "{\"meetingId\":\"202675c9-0700-4472-bb2e-a2d2c2b2c401\"}"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, transform_json_string_1.default)(), (0, class_transformer_1.Type)(() => key_value_1.Metadata), __metadata("design:type", key_value_1.Metadata)], BillingApiReportRefundQueryDto.prototype, "orderMeta", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск операций связанных с начислениями содержащими мета-данные",
  required: false,
  type: String,
  format: "json",
  example: "{\"meetingId\":\"202675c9-0700-4472-bb2e-a2d2c2b2c401\"}"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, transform_json_string_1.default)(), (0, class_transformer_1.Type)(() => key_value_1.Metadata), __metadata("design:type", key_value_1.Metadata)], BillingApiReportRefundQueryDto.prototype, "chargeMeta", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Выплаты созданные начиная с даты",
  required: false,
  type: 'string',
  format: 'date-time'
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDate)(), (0, transform_iso8601_date_1.default)(), __metadata("design:type", Object)], BillingApiReportRefundQueryDto.prototype, "from", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Выплаты созданные до даты",
  required: false,
  type: 'string',
  format: 'date-time'
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDate)(), (0, transform_iso8601_date_1.default)(), __metadata("design:type", Object)], BillingApiReportRefundQueryDto.prototype, "to", void 0);
exports.BillingApiReportRefundQueryDto = BillingApiReportRefundQueryDto;
